import { MEASURE } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export const getMeasureOption = (key: MEASURE): IPickerOption => {
  return { label: key === MEASURE.NULL ? '-' : localeStore.t(key), value: key };
};
